export const END_POINT_LandingSite = 'https://ls.skubiq.com/'
export const END_POINT_SSO ='https://identity.skubiq.com/'
export const END_POINT_SKUBIQWMSURL='https://wms.skubiq.com/'
export const END_POINT_MasterData = 'https://master.skubiq.com/'
